import e from"$app/internal/main";import t from"$app/render/client";t(e.createApp,import.meta.env.APP_NAME);
//# sourceMappingURL=client.js.map